import { render, staticRenderFns } from "./comparablesMatrixTable.vue?vue&type=template&id=028da70a&scoped=true"
import script from "./comparablesMatrixTable.vue?vue&type=script&lang=js"
export * from "./comparablesMatrixTable.vue?vue&type=script&lang=js"
import style0 from "./comparablesMatrixTable.vue?vue&type=style&index=0&id=028da70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028da70a",
  null
  
)

export default component.exports